import Tooltip from "@/tooltip";
import { BuildingOffice2Icon } from "@/icons/solid";
import InfoCard from "@/common/cards/InfoCard";
import { Row } from "@/common/custom-lists/ListView";
import { connect } from "react-redux";
import { Actions as AUTHENTICATION_ACTIONS } from "../../../store/actions/authenticationActions";
import DatePicker from "react-datepicker";
import { DateInputFormat } from "@/common/DateComponents";
import { format } from "date-fns";

const ClientRow = ({ client, switchCompany, view }) => {
	if (view === "Card")
		return (
			<InfoCard
				header={
					<div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}>
						<div style={{ display: "flex", gridColumn: "1 / span 2" }}>
							<h4 style={{ marginLeft: "1rem" }}>{client?.name}</h4>
						</div>
					</div>
				}
				footer={
					<div style={{ display: "flex", justifyContent: "space-between" }}>
						<div className="btn-group">
							<a
								to={`/advisor/team`}
								className="btn btn-xs btn-primary mr-3"
								type="button"
								onClick={(e) => {
									switchCompany(client?.id, `/people`);
								}}
							>
								<BuildingOffice2Icon className="w-6 h-6 media-middle" />
								Switch
							</a>
						</div>
					</div>
				}
			/>
		);

	return (
		<Row
			actionColumns={[0]}
			columns={[
				" ",
				client?.name,
				view === "Normal" && client?.status,
				view === "Enrolment" &&
					(client.nextReassessmentDateDeadline
						? format(new Date(client.nextReassessmentDateDeadline), "dd/MM/yyyy")
						: "N/A"),
				view === "Enrolment" && (client?.contactPerson || "N/A"),
				//view === "Enrolment" && "Notification Date",
				// view === "Enrolment" && "Last Reminder",
				view === "Enrolment" && (client?.autoEnrolmentStatus || "N/A"),
				/*view === "Enrolment" && (
					<DatePicker
						customInput={<DateInputFormat />}
						wrapperClassName="full-width"
					/>
				),*/
				<div className="btn-group">
					<Tooltip
						content={`Switch to ${client?.name}`}
						arrowSize={4}
					>
						<a
							href={`/advisor/team`} // Changed from 'to' to 'href' for correctness if it's meant to be a link (assuming React Router is not being used)
							className="btn btn-xs btn-primary mr-3"
							type="button"
							onClick={(e) => {
								e.preventDefault(); // Prevent default to stop navigation if necessary
								switchCompany(client?.id, `/people`);
							}}
						>
							<BuildingOffice2Icon className="w-6 h-6 media-middle" />
						</a>
					</Tooltip>
				</div>,
			]}
		/>
	);
};

const mapStateToProps = () => {
	return {};
};

const mapDispatchToProps = (dispatch) => ({
	switchCompany: (companyId, link) => dispatch(AUTHENTICATION_ACTIONS.switchCompany(companyId, link)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientRow);
